var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShadowPvpBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 999,
    height: 694,
    viewBox: "0 0 999 694",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2004_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 354.053C182.777 405.852 220.806 447.752 260.422 475.718C300.039 503.684 339.908 516.772 376.188 513.723C412.469 510.673 443.938 491.588 467.563 458.307C491.189 425.025 506.175 378.669 511.078 323.703L281.226 150.002L150 354.053Z",
    fill: "#00C2FF",
    fillOpacity: 0.49
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2004_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M487 383.053C519.777 434.852 557.806 476.752 597.423 504.718C637.039 532.684 676.908 545.772 713.188 542.723C749.469 539.673 780.938 520.588 804.563 487.307C828.189 454.025 843.175 407.669 848.078 352.703L618.226 179.002L487 383.053Z",
    fill: "#39CD74"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2004_12",
    x: 0,
    y: 0.00195312,
    width: 661.078,
    height: 664.154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_2004_12"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2004_12",
    x: 337,
    y: 29.002,
    width: 661.078,
    height: 664.154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_2004_12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowPvpBlock);
export default __webpack_public_path__ + "static/media/shadowPvpBlock.08111fcbad96c532521caa964ed6d2e1.svg";
export { ForwardRef as ReactComponent };